// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Screen{width:100%;height:100%;background-color:#011731;position:relative;overflow:auto;-webkit-overflow-scrolling:touch;overflow-x:hidden}.Screen.modal-open{overflow:hidden}.Screen__container{width:100%;max-width:1400px;min-height:100%;margin-left:auto;margin-right:auto;padding:1em}.Screen--visible{filter:unset}.Screen--hidden{filter:blur(2px)}", ""]);
// Exports
module.exports = exports;
